import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';

export interface ICancelExtractCreationParams extends IMultipleIdsParams {
  contentType: string;
}

export class CancelExtractCreationRequest extends Request<ICancelExtractCreationParams, IResult> {
  constructor(contentIds: string[], contentType: string) {
    super('cancelExtractCreation', {
      ids: contentIds,
      contentType: contentType
    });
  }
}
